// libs
import { styled } from '@nykaa/ui-components';

//components
import BaseButton from '@nykaa/ui-components/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${({ theme }) => `${theme.spacing.spacing480} ${theme.spacing.spacing640}`};
`;

export const Image = styled.img`
  background-repeat: no-repeat;
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.titleLarge};
  ${({ theme }) => `margin: ${theme.spacing.spacing160} 0 ${theme.spacing.spacing60} 0;`};
`;

export const SubTitle = styled.div`
  max-width: 318px;
  ${({ theme }) => theme.typography.bodyLarge};
  margin-bottom: ${({ theme }) => `${theme.spacing.spacing100}`};
`;

export const Button = styled(BaseButton)`
  ${({ theme }) => theme.typography.buttonLarge};
  ${({ theme }) =>
    `padding: ${theme.spacing.spacing40} ${theme.spacing.spacing480};
    background: ${theme.colors.primary};
    color: ${theme.colors.textInversePrimary};
    border-radius: ${theme.borders.buttonBorderRadius};
  `};
`;
